// Vendor modules
import 'angular-ui-bootstrap';
import "../extensions/ae-datetimepicker";
import '../fe-control';

import RenderTemplateComponent from './render-template/render-template.component';
import RenderDynamicComponent from './render-dynamic/render-dynamic.component';
import BehaviorService from './services/behavior.service';
import ActionService from './services/action.service';
import GeoLocationService from './services/geo-location.service';
import TokenRefreshService from '../services/token-refresh.service';
import RenderService from './services/render.service';

const DEPENDENCIES = [
  'ui.bootstrap',
  'fe-control',
  'ae-datetimepicker'
];

angular
  .module('ais.form-render', DEPENDENCIES)
  .component('renderTemplate', RenderTemplateComponent)
  .component('renderDynamic', RenderDynamicComponent)
  .service('BehaviorService', BehaviorService)
  .service('ActionService', ActionService)
  .service('GeoLocationService', GeoLocationService)
  .service('TokenRefreshService', TokenRefreshService)
  .service('RenderService', RenderService)
  .directive('imageonload', () => {
    return {
      restrict: 'A',
      scope: {
        imageonload: '='
      },
      link: (scope, element, attrs) => {
        element.bind('load', () => {
          scope.$apply(() => scope.imageonload = true);
        });
        element.bind('error', () => {
          console.error('image could not be loaded');
          scope.$apply(() => scope.imageonload = false);
        });
      }
    };
  });
